<template>
  <WsMain>
    <WsCRUD
      v-if="isMounted"
      liveSearching
      :label="label"
      :fields="fields"
      :pageMode="true"
      :showExpand="false"
      :rowClickRead="true"
      :isCreatable="false"
      :modelName="modelName"
      :inRowBtnUpdate="false"
      :inRowBtnDelete="false"
      :showFields="showFields"
      :filterProps="filterProps"
      :filterSelects="filterSelects"
      :customUrlParams="customUrlParams"
      @filter-select="$_onFilterSelect($event)"
    />
  </WsMain>
</template>

<script>
import model from '@/models/act_cnt_update';
import idtfModel from '@/models/act_idtf_assignment';

export default {
  data() {
    return {
      isMounted: false,
      modelName: model.modelName,
      label: model.label,
      fields: idtfModel.fields,
      filterSelects: [
        {
          type: 'switch-tabs',
          modelName: 'act_cnt_status',
          defaultValue: '1',
          items: [
            {
              text: '更新中',
              value: '1',
            },
            {
              text: '已完成',
              value: '2,3',
            },
          ],
        },
      ],
      filterProps: {},
      showFields: [
        'act_version',
        'km_owners',
        'km_backups',
        'km_reviewers',
        'act_cnt_updated_admin',
        'act_cnt_updated_at',
      ],
      customUrlParams: {
        status: '2'
      },
    };
  },
  methods: {
    $_onFilterSelect($event) {
      this.filterProps = {
        ...$event
      };
    },
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>